// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"d88a5fdb","605":"3ecce5f2","809":"62452d41","981":"7ef321f9"}[chunkId] + ".chunk.js";
};